import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "@kui/foundations-react";
import "../../styles/kui-base.css";

/**
 * @description Full-page transition shown while a sign-in redirect is in
 * flight (RWA -> /sso/start -> Starfleet -> /callback), so the login form
 * never flashes in between. Uses the same Kaizen Spinner as the RWA app.
 */
function AuthTransition({ message }) {
  return (
    <div
      className="kui-scope"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fff",
      }}
    >
      <Spinner slotDescription={message} />
    </div>
  );
}

AuthTransition.defaultProps = {
  message: "Signing you in...",
};

AuthTransition.propTypes = {
  message: PropTypes.string,
};

export default AuthTransition;
